import React from "react";
import { CATEGORY_LABELS } from "@/lib/api";
import {
  AlertCircle, FileWarning, Repeat, PlusCircle, MessageCircle,
  FlaskConical, ClipboardList, HelpCircle,
} from "lucide-react";

const icons = {
  valore_allarme: AlertCircle,
  errore_richiesta: FileWarning,
  ripetere_esame: Repeat,
  aggiungere_esame: PlusCircle,
  richiesta_prescrizione: FlaskConical,
  richiesta_consulto: ClipboardList,
  richiesta_chiarimento: HelpCircle,
  generica: MessageCircle,
};

export default function CategoryBadge({ category, className = "" }) {
  const Icon = icons[category] || MessageCircle;
  return (
    <span
      data-testid={`category-badge-${category}`}
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md text-[11px] font-semibold text-slate-700 bg-slate-100 border border-slate-200 ${className}`}
    >
      <Icon className="h-3 w-3" strokeWidth={2.4} />
      {CATEGORY_LABELS[category] || category}
    </span>
  );
}
